import React from 'react';
import Modal from './modal';

export default function ContactModal({ onClose }) {
  return (
    <Modal title="Contact Us" onClose={onClose}>
      <p>Have a question, correction, or partnership enquiry? We'd love to hear from you.</p>

      <h3>General Enquiries</h3>
      <p>Email: <a href="mailto:info@londoncasinodeals.com">info@londoncasinodeals.com</a></p>

      <h3>Editorial & Review Queries</h3>
      <p>If you have a query about our casino reviews, ratings, or editorial process, please email our editorial team.</p>

      <h3>Advertising & Partnerships</h3>
      <p>For affiliate partnerships or advertising opportunities, contact us via email and our partnerships team will respond within 2 business days.</p>

      <h3>Responsible Gambling Concerns</h3>
      <p>If you or someone you know has a gambling problem, please do not contact us — instead, reach out directly to dedicated support organisations:</p>
      <ul>
        <li><a href="https://www.begambleaware.org/" target="_blank" rel="noopener noreferrer nofollow">BeGambleAware</a> — 0808 8020 133</li>
        <li><a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer nofollow">GamCare</a> — National Gambling Helpline 0808 8020 133</li>
        <li><a href="https://www.gamstop.co.uk/" target="_blank" rel="noopener noreferrer nofollow">GAMSTOP</a> — Free self-exclusion service</li>
      </ul>

      <h3>Response Times</h3>
      <p>We aim to respond to all enquiries within 2 working days (Monday–Friday, UK business hours).</p>
    </Modal>
  );
}
